export class TranslationContainerComponent {

    TRANSLATIONS_CONTAINER = '';

    constructor(translationsContainer: string) {
        this.TRANSLATIONS_CONTAINER = translationsContainer;
    }

    getTranslationKey(suffix: string): string {
        return `${this.TRANSLATIONS_CONTAINER}.${suffix}`;
    }
}
